'use client';

import Image from 'next/image';
import {Avatar} from '@udemy-v2/react-core-components';
import classNames from 'classnames';

import styles from './community-powered-badge.module.scss';

export type CommunityPoweredBadgeSize = 'sm' | 'lg';

const ASSET_BASE = (process.env.ASSET_PREFIX ?? '').replace(/\/$/, '');
const COMMUNITY_POWERED_BADGE_SM = `${ASSET_BASE}/community-powered-sm-en-us-v1.png`;

export interface CommunityPoweredBadgeProps {
    imageUrl: string;
    displayName: string;
    url?: string;
    size?: CommunityPoweredBadgeSize;
    className?: string;
    'data-purpose'?: string;
}

export function CommunityPoweredBadge({
    imageUrl,
    displayName,
    url,
    size = 'lg',
    className,
    'data-purpose': dataPurpose = 'instructor-image',
}: CommunityPoweredBadgeProps) {
    const content = (
        <>
            <Image
                className={styles['community-powered']}
                src={COMMUNITY_POWERED_BADGE_SM}
                alt=""
                width={size === 'sm' ? 60 : 154}
                height={size === 'sm' ? 60 : 154}
                unoptimized
            />
            <Avatar
                className={classNames(
                    styles.avatar,
                    size === 'sm' ? styles['avatar-sm'] : styles['avatar-lg'],
                )}
                user={{
                    display_name: displayName,
                    image_200_H: imageUrl,
                }}
                srcKey="image_200_H"
                alt="NONE"
            />
        </>
    );

    const containerClassName = classNames(
        styles['badge-container'],
        size === 'sm' ? styles['badge-container-sm'] : styles['badge-container-lg'],
        className,
    );

    if (url) {
        return (
            <a
                href={url}
                className={containerClassName}
                data-purpose={dataPurpose}
                aria-label={displayName}
            >
                {content}
            </a>
        );
    }

    return (
        <div className={containerClassName} data-purpose={dataPurpose}>
            {content}
        </div>
    );
}
